import React from 'react';
import '../../Default.css';
import type LinkItem from './linkType'
import links_file from "./links.json"
const links: LinkItem[] = links_file as any;


function Links() {
    return (
      <>
        <div className="page-title">
          Pobierz lub zachowaj
        </div>
        <div className='boxes-contener'>
          <div className='copyright-tekst'>Niektóre opisy i linki są zaczerpnięte ze strony MSZ</div>
          <div className="text">
            <div className="paragraf">
              {links.map((item,index) => (
                  <a href={item.link} key={index.toString()}>
                    <div className='text-box-header'>{item.title}</div>
                      <p>{item.description}</p>
                  </a>
              ))}
            </div>
          </div>
        </div>
      </>
    );
}

export default Links;
